import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SessionRepository } from '@app-core/state/session.repository';
import { map } from 'rxjs';

/**
 * If a user visits a route with this guard, he will be logged out.
 *
 * Example:
 * Logged in user goes to `/login`, he is allowed to go there, but
 * will be logged out in the process.
 */
export const notAuthGuard: CanActivateFn = (_route, _state) => {
  const sessionRepo = inject(SessionRepository);

  return sessionRepo.isLoggedIn$.pipe(
    map(isLoggedIn => {
      // we need to keep the saved route incase the user was going to
      // a expired password page or something like that
      if (isLoggedIn) sessionRepo.resetStore('savedRoute');

      return true;
    }),
  );
};
